import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { search } from 'ss-search';
import { alerts } from '../../actions/Alerts';
import { updateCart } from '../../actions/Cart';
import { getCategories } from '../../actions/Categories';
import { getAllItems } from '../../actions/Items';
import { getOutlets } from '../../actions/Locations';
import CONSTANTS from '../../constants';
import ViewHelper from '../../helpers/ViewHelper';
import ItemList from './ItemList';
import ItemModal from './ItemModal';
const swipeIcons = {
  right: faPlus,
  left: faTrashAlt
};


class Items extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedItem: null
    };
  }

  componentDidMount() {
    if (!this.props.items) this.props.getAllItems(this.props._location, this.props.history);
    if (!this.props.categories)
      this.props.getCategories(
        this.props._location.menu_blob,
        this.props._location.loc_id,
        this.props.history
      );
  }
  componentDidUpdate(prevProps) {
    if (!(this.props.history.location.pathname.indexOf('/item/') > -1)) {
      setTimeout(() => {
        let item = localStorage.getItem('selectedItem');
        if (item) {
          item = JSON.parse(item);
          let menu_name = item.menu_name.replace(/ /g, '-');
          this.redirectToItem(`/${this.props._location.slug}/item/${menu_name}-${item.menu_id}`, item);
          localStorage.setItem('selectedItem', '');
        }
      }, 1000);
    }
  }
  render() {
    let { cat_items, items, categories, _location, promotions, selectedOutlet, searchText, order_type_id } =
      this.props;

    let datas = items ? (items.length ? (items.length > 0 ? items : []) : []) : [];

    let menus = search(datas, ['category_name', 'menu_name'], searchText);

    let category = [];
    if (cat_items && cat_items.length > 0) {
      for (let i = 0; i < cat_items.length; i++) {
        let categories = cat_items[i];
        let menus = categories.menu;
        let datas = search(menus, ['category_name', 'menu_name'], searchText);
        categories.menu = datas;
        category.push(categories);
      }
    }

    if (menus && categories && menus.length > 0 && categories.length > 0) {
      return (
        <>
          <ItemList
            location={_location}
            items={menus}
            categories={categories}
            promotions={promotions}
            selectedOutlet={selectedOutlet}
            layout={this.props.layout}
            redirectToItem={this.redirectToItem}
            onItemSelected={this.onItemSelected}
            outlets={this.props.outlets}
            order_type_id={order_type_id}
            removeFromCart={this.props.removeFromCart}
            addToCart={this.props.addToCart}
          />
          {this.state.showModal && (
            <ItemModal
              isOrderingEnabled={this.props.isOrderingEnabled}
              toggleModal={this.toggleModal.bind(this)}
              closeModal={this.closeModal.bind(this)}
              togglePrefModal={this.props.togglePrefModal}
              toggleRouteModal={this.props.toggleRouteModal}
              item={this.state.selectedItem}
              location={_location} s
              locationSettings={this.props.locationSettings}
              showModal={this.state.showModal}
              updateCart={this.props.updateCart}
              toast={this.props.toast}
              getToastSettings={this.props.getToastSettings}
            />
          )}
        </>
      );
    } else {
      return (<p className='text-center text-bold card-subtitle-color'>No items available at this time.</p>)
    }
    return '';
  }

  onItemSelected = (item) => {
    this.setState({ selectedItem: item });
    this.toggleModal();
  };

  toggleModal() {
    const { props } = this;
    if (this.state.showModal) {
      if (props.history.length > 2) {
        if (this.props._location) {
          ViewHelper.setDocumentTitle(this.props._location?.meta.title);
          ViewHelper.setDocumentDescription(this.props._location?.meta.description);
          ViewHelper.setDocumentKeywords(this.props._location?.meta.keywords);
          ViewHelper.setMetaKeywords(this.props._location?.meta.keywords);
        }
        props.history.replace(`${CONSTANTS.BASE_URL}${props._location.slug}`);
        // props.history.goBack();
      } else {
        if (this.props._location) {
          ViewHelper.setDocumentTitle(this.props._location?.meta.title);
          ViewHelper.setDocumentDescription(this.props._location?.meta.description);
          ViewHelper.setDocumentKeywords(this.props._location?.meta.keywords);
          ViewHelper.setMetaKeywords(this.props._location?.meta.keywords);
        }
        props.history.replace(`${CONSTANTS.BASE_URL}${props._location.slug}`);
      }
    }
    this.setState({ showModal: !this.state.showModal });
  }
  closeModal() {
    if (this.props._location) {
      ViewHelper.setDocumentTitle(this.props._location?.meta.title);
      ViewHelper.setDocumentDescription(this.props._location?.meta.description);
      ViewHelper.setDocumentKeywords(this.props._location?.meta.keywords);
      ViewHelper.setMetaKeywords(this.props._location?.meta.keywords);
    }
    this.setState({ showModal: !this.state.showModal });
  }

  redirectToItem = (link, item) => {
    this.onItemSelected(item);
    ViewHelper.setCanonical(link);
    return this.props.history.push(link);
  };
}

function mapStateToProps(state) {
  const { location, locationSettings, categories, items, cat_items, promotions, toast, childLocations } = state;
  return {
    categories,
    cat_items,
    items,
    promotions,
    toast: toast?.toast,
    outlets: childLocations,
    _location: location,
    locationSettings
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getAllItems,
    getOutlets,
    getCategories,
    updateCart,
    getToastSettings: alerts.getToastSettings
  })(Items)
);
